import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '@honda-canada/design-system-react';
const AnimatedLoader = ({ isMobile = false, showIcon = true }) => (_jsx(Icon, { name: "animated360Loader", showIcon: showIcon, iconSize: isMobile ? 'small' : 'large' }));
export default AnimatedLoader;
